<div *ngIf="(file_path?.length ?? 0) > 1" class="input-group flex-nowrap">
  <span class="input-group-text text-primary file-type-icon">
    <i class="bi {{ getFileIcon() }}"></i>
  </span>
  <div class="form-control form-control-lg form-control-solid">
    <a target="_blank" href="{{ (file_path ?? '') |  fileDownloadPath }}"
      class="text-primary fw-bold">{{ file_path && (file_path.length > 30 ? '...' : '') + (file_path | slice: -30) || '--' }}</a>
  </div>
  <a class="input-group-text bg-primary text-white border-primary" target="_blank"
    href="{{ (file_path ?? '') |  fileDownloadPath }}">
    <i class="bi bi-download fw-bold"></i>
  </a>
</div>
<div *ngIf="(file_path?.length ?? 0) == 0" class="form-control form-control-lg form-control-solid">--</div>
